document.addEventListener('DOMContentLoaded', function () {
  const select = document.getElementById('product-select');
  const productNameField = document.getElementById('product_name'); // Hidden product name field

  if (!select || !productNameField) return;

  // Disable the select while loading
  select.disabled = true;
  select.innerHTML = '<option>Indlæser produkter...</option>';

  // Fetch the product list
  fetch(contactForm7Vars.ajax_url + '?action=get_product_list')
    .then(res => res.json())
    .then(products => {
      // Clear and add default option
      select.innerHTML = '';
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.text = 'Vælg produkt her';
      select.appendChild(defaultOption);

      // Add product options
      products.forEach(product => {
        const option = document.createElement('option');
        option.value = product.id;
        option.text = product.name;
        select.appendChild(option);
      });

      // Re-enable after loading
      select.disabled = false;

      // Preselect if product_id is present
      const urlParams = new URLSearchParams(window.location.search);
      const preselectId = urlParams.get('product_id');
      if (preselectId) {
        select.value = preselectId;
        // Also set the hidden field product_name
        const selectedProduct = products.find(product => product.id == preselectId);
        if (selectedProduct) {
          productNameField.value = selectedProduct.name;
        }
      }
    });

  // Add an event listener to handle changes in the select field
  select.addEventListener('change', function () {
    var productId = select.value;

    if (productId) {
      // Fetch product name and set the hidden field
      fetch('/wp-json/custom-api/v1/product-name/' + productId)
        .then(response => response.json())
        .then(data => {
          if (data.product_name) {
            productNameField.value = data.product_name; // Set product name in hidden field
          }
        })
        .catch(error => console.error('Error fetching product name:', error));
    }
  });

  // Add an event listener to handle form submission
  document.addEventListener('wpcf7submit', function (event) {
    // If needed, you can also ensure the hidden field product_name is set here.
    // This is just a precaution in case the select change was not triggered.
    if (!productNameField.value) {
      var productId = select.value;
      if (productId) {
        fetch('/wp-json/custom-api/v1/product-name/' + productId)
          .then(response => response.json())
          .then(data => {
            if (data.product_name) {
              productNameField.value = data.product_name; // Set product name in hidden field
            }
          })
          .catch(error => console.error('Error fetching product name:', error));
      }
    }
  }, false);
});
